import React from 'react'
import Packages from '../components/packages'

function membership() {
  return (
    <div>
      <Packages />
    </div>
  )
}

export default membership